import React from 'react';
import { Lightbulb } from 'lucide-react';
export const NaYin: React.FC = () => {
  const nayinGroups = [{
    name: '海中金',
    pairs: '甲子、乙丑',
    desc: '深藏不露，需经磨练方成大器。'
  }, {
    name: '炉中火',
    pairs: '丙寅、丁卯',
    desc: '热情奔放，能炼金化土。'
  }, {
    name: '大林木',
    pairs: '戊辰、己巳',
    desc: '枝繁叶茂，庇荫他人。'
  }, {
    name: '路旁土',
    pairs: '庚午、辛未',
    desc: '平易近人，承载万物。'
  }, {
    name: '剑锋金',
    pairs: '壬申、癸酉',
    desc: '锋芒毕露，刚毅果断。'
  }, {
    name: '山头火',
    pairs: '甲戌、乙亥',
    desc: '光芒四射，气势磅礴。'
  }];
  return <div className="space-y-12" data-id="element-228">
      <div className="text-center mb-10" data-id="element-229">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-230">
          六十甲子纳音
        </h1>
        <p className="text-ink-light" data-id="element-231">
          天干地支结合后产生的新五行属性，如同化学反应。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-232">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-233">
          <Lightbulb size={24} data-id="element-234" />
        </div>
        <div data-id="element-235">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-236">
            小白理解法：什么是纳音？
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-237">
            如果把天干比作"父亲"，地支比作"母亲"，那么纳音就是他们生出来的"孩子"。
            <br data-id="element-238" />
            比如：甲(木) + 子(水) = 海中金。这个"金"就是纳音五行。
            <br data-id="element-239" />
            纳音常用于判断性格的深层底色，以及两人合婚时的气场契合度。
          </p>
        </div>
      </div>

      <section className="space-y-6" data-id="element-240">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-241">
          常见纳音意象 (部分展示)
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-242">
          {nayinGroups.map((group, idx) => <div key={idx} className="bg-white ink-border p-5 rounded-lg card-hover shadow-sm" data-id="element-243">
              <div className="flex justify-between items-center mb-3" data-id="element-244">
                <h3 className="text-xl font-serif font-bold text-gold-dark" data-id="element-245">
                  {group.name}
                </h3>
                <span className="text-sm bg-paper px-2 py-1 rounded text-ink-light font-medium" data-id="element-246">
                  {group.pairs}
                </span>
              </div>
              <p className="text-ink-light text-sm" data-id="element-247">{group.desc}</p>
            </div>)}
        </div>
        <div className="text-center mt-6" data-id="element-248">
          <p className="text-ink-light/70 text-sm" data-id="element-249">
            六十甲子共有三十个纳音，此处仅列举前六个作为教学示例。
          </p>
        </div>
      </section>
    </div>;
};